// extracted by mini-css-extract-plugin
export default {"container":"TeamInvitation_container__4hysj","centered":"TeamInvitation_centered__48He5"};